import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: 50px;  
  padding-block: 20px;  
  gap: 20px;
`;

export const InfoContainer = styled.div`
  width: 80%;
  
  @media (max-width: 1024px) {
    width: 60%;
    padding: 30px;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 20px;
  }
`;

export const OrderHeader = styled.div`
  background-color: ${props => props.theme.colors.card};
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;

  padding: 20px;

  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
`;

export const OrderDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const OrderItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const HeaderTitle = styled.span`
  font-weight: 700;
  color: ${props => props.theme.colors.text};
`;

export const ContentTitle = styled.span`
  font-weight: 700;
  font-size: 14px;
  color: ${props => props.theme.colors.text};
`;

export const ContentSubtitle = styled.span`
  font-size: 16px;
  color: ${props => props.theme.colors.text};
`;

export const PedidoWrapper = styled.div`
  border: 1px solid;
  padding-bottom: 20px;
  border-color: ${props => props.theme.colors.border_grey};
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
`;

export const PedidoContent = styled.div`
  padding: 10px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PedidoFooter = styled.div`
`;
